// @ftedn/shared — Role & permission constants

export const ROLES = {
  EEDUNER: 'eeduner',
  STAFF: 'staff',
  ADMIN: 'admin',
} as const;

export type PlatformRole = typeof ROLES[keyof typeof ROLES];

export const LEGACY_ROLE_ALIASES: Record<string, PlatformRole> = {
  eeduner: ROLES.EEDUNER,
  creator: ROLES.EEDUNER,
  staff: ROLES.STAFF,
  member: ROLES.STAFF,
  manager: ROLES.STAFF,
  viewer: ROLES.STAFF,
  admin: ROLES.ADMIN,
};

export const SURFACE_ACCESS = {
  creator: [ROLES.EEDUNER, ROLES.STAFF, ROLES.ADMIN],
  team: [ROLES.STAFF, ROLES.ADMIN],
} as const;

export function normalizeRole(role?: string | null): PlatformRole {
  if (!role) return ROLES.EEDUNER;
  return LEGACY_ROLE_ALIASES[role] ?? ROLES.EEDUNER;
}

export function isStaffRole(role?: string | null) {
  return normalizeRole(role) !== ROLES.EEDUNER;
}
